import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3560_20594",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_3560_20594)",
		children: /* @__PURE__ */ _jsx("path", { d: "M4.21157 5.74998V4.25003H19.7885V5.74998H4.21157ZM4.25004 19.75V13.75H3.13464V12.25L4.21157 7.25003H19.7885L20.8654 12.25V13.75H19.75V19.75H18.25V13.75H13.75V19.75H4.25004ZM5.74999 18.25H12.25V13.75H5.74999V18.25ZM4.66537 12.25H19.3347L18.5712 8.74998H5.42884L4.66537 12.25Z" })
	})]
});
export default SvgStore;
